import { GoogleLoginButton } from './GoogleLoginButton';
import { LinkedInLoginButton } from './LinkedInLoginButton';
import { MicrosoftLoginButton } from './MicrosoftLoginButton';
import { CollapsiblePhoneAuth } from './CollapsiblePhoneAuth';


interface SSOButtonGroupProps {
  onGoogleClick: () => void;
  onLinkedInClick: () => void;
  onMicrosoftClick: () => void;
  onPhoneSubmit: (phoneNumber: string) => void;
  onOTPSubmit: (otp: string) => void;
  showOTP?: boolean;
  phoneNumber?: string;
  disabled?: boolean;
  hideMicrosoft?: boolean;
  hidePhone?: boolean;
}

export const SSOButtonGroup = ({ 
  onGoogleClick,
  onLinkedInClick, 
  onMicrosoftClick,
  onPhoneSubmit,
  onOTPSubmit,
  showOTP,
  phoneNumber,
  disabled,
  hideMicrosoft = false,
  hidePhone = false
}: SSOButtonGroupProps) => {
  return (
    <div className="space-y-3">
      <GoogleLoginButton onClick={onGoogleClick} disabled={disabled} />
      {!hideMicrosoft && (
        <MicrosoftLoginButton onClick={onMicrosoftClick} disabled={disabled} />
      )}
      <LinkedInLoginButton onClick={onLinkedInClick} disabled={disabled} />
      {!hidePhone && (
        <CollapsiblePhoneAuth 
          onPhoneSubmit={onPhoneSubmit}
          onOTPSubmit={onOTPSubmit}
          disabled={disabled}
          showOTP={showOTP}
          phoneNumber={phoneNumber}
        />
      )}
    </div>
  );
};